import React from "react";
import ProjectForm from "./forms/ProjectForm";
const GeneralInformation: React.FC = () => {
  return <ProjectForm  />;
};

export default GeneralInformation;
